import React from "react";
import DivContainerBody from "../../../../../../../../components/DivContainerBody";
import {IconPersonArrow} from "../../../../../../../../components/buttons/IconButtons";
import SummaryContainerDetails from "./SummaryContainerDetails";
import SummaryContainerDevices from "./SummaryContainerDevices";
import SummaryContainerDepartments from "./SummaryContainerDepartments";
import SummaryContainerCustomAccess from "./SummaryContainerCustomAccess";
import SummarySection from "../../../../../../../../components/Summary/SummarySection";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Final step of the create shift access flow. Read-only recap of the shift:
 * details (name), devices access, departments and custom access. Mirrors the
 * Devices Summary methodology (titled SummarySection wrapper + per-section
 * SummaryContainer components fed by the local selection lists).
 */
const Summary = ({
                     t,
                     item,
                     devices = [],
                     departments = [],
                     user = [],
                 }) => {

    return (
        <DivContainerBody>
            <SummarySection icon={IconPersonArrow} title={t('access')}>
                <SummaryContainerDetails data={item} t={t} />
            </SummarySection>

            <SummaryContainerDevices t={t} selected={devices} />

            <SummaryContainerDepartments t={t} selected={departments} />

            <SummaryContainerCustomAccess t={t} selected={user} />
        </DivContainerBody>
    );
};

export default Summary;
